import React, { ReactNode } from "react";

import "./styles.scss";

export default function PageContainer(props: {
  children: ReactNode;
}): React.JSX.Element {
  return <div className="scd-page-container">{props.children}</div>;
}
